import {ENTITY_SERVICE_REGISTRY, EntityServiceEntry} from "../../core/shared/dto/dto-service/entity-service-registry";
import {DqAuditGroupService} from "./service/api/dq-audit-group.service";
import {DqAuditCheckService} from "./service/api/dq-audit-check.service";
import {DqAuditRunService} from "./service/api/dq-audit-run.service";
import {DqAuditFindingService} from "./service/api/dq-audit-finding.service";
import {DqAuditFindingCommentService} from "./service/api/dq-audit-finding-comment.service";

/**
 * Entity registry of the dq (Data Quality) module.
 *
 * The route segment of every entry is a VERBATIM copy of the literal in the backend controller's
 * {@code @RequestMapping} ({@code /mvsa/dq/auditGroups}, {@code /auditChecks}, {@code /auditRuns},
 * {@code /auditFindings}, {@code /auditFindingComments} — 04-bauauftrag.md section 7). It is derived
 * from NOTHING: neither the entity name nor the alias produces it, so it must never be assembled in
 * the frontend.
 *
 * Every alias now carries its {@code service:} entry. Each service binds the same literal through
 * {@code MvsCrudService.baseUrl + '/dq/…'} and adds, on top of the generic CRUD, the German object
 * labels and the object icon that the object dialogs, search results and object headers render.
 *
 * {@code dq.DqAuditFindingComment} has been ADDED to the registry — it was missing while no service
 * existed for it, but the review work bench renders the comment history of a finding and resolves
 * it through this alias.
 *
 * Note for consumers: the finding WORK LIST does not go through any of these routes. It reads via QL
 * ({@code DqAuditFindingQlService}) because the generic list endpoint ignores {@code page}/{@code
 * size} and returns the whole table, and {@code dq_audit_finding} is the one expectedly large table
 * of this module.
 */
export const DQ_ENTITY_PROVIDER = [
    {
        provide: ENTITY_SERVICE_REGISTRY,
        useValue: [
            ['dq.DqAuditGroup', {route: '/dq/auditGroups', service: DqAuditGroupService}],
            ['dq.DqAuditCheck', {route: '/dq/auditChecks', service: DqAuditCheckService}],
            ['dq.DqAuditRun', {route: '/dq/auditRuns', service: DqAuditRunService}],
            ['dq.DqAuditFinding', {route: '/dq/auditFindings', service: DqAuditFindingService}],
            ['dq.DqAuditFindingComment', {
                route: '/dq/auditFindingComments',
                service: DqAuditFindingCommentService
            }],
        ] as EntityServiceEntry[],
        multi: true
    }
];
